/*
 * Copyright (c) CIRROM 2021.
 */

import { IntegratedSystemDetail } from "../../api/integratedsystems";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useRef } from "react";
import { indigo } from "@mui/material/colors";
import { VectorMap } from "@react-jvectormap/core";
import { worldMill } from "@react-jvectormap/world";

export const ComplianceMap = React.memo(function ComplianceMap(props: {
  systemDetails: IntegratedSystemDetail;
  onMarkerClick?: (event, index) => void;
  containerStyle?: any;
}) {
  const { containerStyle, onMarkerClick, systemDetails } = props;
  const mapRef = useRef(null);
  const countPerMarker =
    systemDetails?.crm_stats.contact_locations.map((entry) => entry.count) || 0;

  const theme = useTheme();

  useEffect(() => {
    if (
      mapRef?.current?.markers &&
      Object.keys(mapRef.current.markers).length > 0 &&
      Object.keys(mapRef.current.markers).length < 25
    ) {
      const latitudeLongitude = mapRef.current.markers[0].config.latLng;
      mapRef.current.setFocus({
        scale: 3,
        lat: latitudeLongitude[0],
        lng: latitudeLongitude[1],
      });
    }
  }, [mapRef]);

  return (
    <VectorMap
      map={worldMill}
      mapRef={mapRef}
      backgroundColor={theme.palette.background.paper}
      style={containerStyle || { width: "100%", height: "100%" }}
      regionStyle={{
        initial: {
          fill: theme.palette.mode === "dark" ? "#666f7d" : "#e2eaef",
        },
      }}
      markers={(systemDetails?.crm_stats.contact_locations || []).map(
        (item) => {
          return {
            name: item.title,
            latLng: [item.lat, item.long],
            count: new Intl.NumberFormat("en-US").format(item.count),
          };
        }
      )}
      series={{
        markers: [
          {
            attribute: "r",
            scale: [3, 8],
            values: countPerMarker,
          },
        ],
      }}
      markerStyle={{
        initial: {
          fill: theme.palette.secondary.main,
          fillOpacity: 1,
          stroke: "#fff",
          strokeWidth: 7,
          strokeOpacity: 0.4,
        },
        hover: {
          stroke: "#fff",
          fillOpacity: 1,
          strokeWidth: 1.5,
        },
      }}
      onMarkerClick={onMarkerClick}
      markersSelectableOne={Boolean(onMarkerClick)}
      markersSelectable={Boolean(onMarkerClick)}
      onMarkerTipShow={(_event, _label, index) => {
        mapRef.current.tip.text(
          systemDetails.crm_stats.contact_locations[index].title +
            "(" +
            new Intl.NumberFormat("en-US").format(
              systemDetails.crm_stats.contact_locations[index].count
            ) +
            ")"
        );
      }}
    />
  );
});
